import { IntegrationKind } from "@redotech/redo-integrations-core";
import * as z from "zod/v4";

export const backfillCustomers = {
  name: "backfillCustomers" as const,
  input: z.object({ kind: z.enum(IntegrationKind) }),
  output: z.object({
    success: z.boolean(),
    workflowId: z.string(),
    error: z.string().optional(),
  }),
};
